// extracted by mini-css-extract-plugin
export var center = "pane-title-module--center--45278";
export var description = "pane-title-module--description--0be26";
export var heading = "pane-title-module--heading--345db";
export var paneTitle = "pane-title-module--pane-title--75e58";
export var red = "pane-title-module--red--cc533";
export var white = "pane-title-module--white--f1a16";